import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'
import Creatable from 'react-select/creatable';

// https://www.npmjs.com/package/react-datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";
import { getFileData } from 'utils/general'

function EditarInvestigacion(props) {
	const { investigacionOriginal, etiquetasExistentes, guardar, setQueMostrar } = props
	const [etiquetas, setEtiquetas] = useState(
		investigacionOriginal.etiquetas?.map(elem => ({ label: elem.nombre, value: elem.id })) || []
	)

	registerLocale('es', es)

	const [datos, setDatos] = useState({
		id: investigacionOriginal.id,
		fechaPublicacion: new Date(investigacionOriginal.fechaPublicacion),
		autor: investigacionOriginal.autor,
		titulo: investigacionOriginal.titulo,
		planta: investigacionOriginal.planta,
		documento: false,
	})

	const [erroresValidacion, setErroresValidacion] = useState({})

	const opciones = etiquetasExistentes.map(elem => ({ label: elem.nombre, value: elem.id }))

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		// verifica si se eliminó alguna etiqueta
		const etiquetasIds = etiquetas.map(elem => elem.value)
		const eliminarEtiquetasIds = []

		if (investigacionOriginal.etiquetas) {
			investigacionOriginal.etiquetas.forEach(etiqueta => {
				if (!etiquetasIds.includes(etiqueta.id)) {
					eliminarEtiquetasIds.push(etiqueta.id)
				}
			})
		}

		const data = {
			...datos,
			etiquetas: etiquetas.map(elem => elem.label)
		}

		if (eliminarEtiquetasIds.length > 0) {
			data.eliminarEtiquetasIds = eliminarEtiquetasIds
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['autor', 'titulo', 'planta']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datos[campo].toString().trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const handleSeleccionDocumento = (files, cual) => {
		setDatos({ ...datos, [cual]: files[0] })
	}

	const documentoFileData = getFileData(investigacionOriginal.documento?.url)

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar Investigación" />
			<Offcanvas.Body id="editar-investigacion">
				<h1>Campos de la investigación</h1>
				{datos.id && (<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="investigacion-titulo">
										<FormLabel>Título</FormLabel>
										<Form.Control
											value={datos.titulo}
											onChange={(e) => handleChange(e.target.value, 'titulo')}
											isInvalid={erroresValidacion.titulo}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.titulo}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="investigacion-autor">
										<FormLabel>Autor</FormLabel>
										<Form.Control
											value={datos.autor}
											onChange={(e) => handleChange(e.target.value, 'autor')}
											isInvalid={erroresValidacion.autor}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.autor}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="investigacion-fechaPublicacion">
										<FormLabel>Fecha publicación</FormLabel>
										<DatePicker
											selected={datos.fechaPublicacion}
											onChange={(fecha) => handleChange(fecha, 'fechaPublicacion')}
											showTimeSelect
											locale='es'
											dateFormat="dd/MM/yyyy HH:mm"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="investigacion-planta">
										<FormLabel>Planta</FormLabel>
										<Form.Control
											value={datos.planta}
											onChange={(e) => handleChange(e.target.value, 'planta')}
											isInvalid={erroresValidacion.planta}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.planta}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="investigacion-etiquetas">
										<FormLabel>Etiquetas</FormLabel>
										<Creatable
											defaultValue={etiquetas}
											onChange={setEtiquetas}
											options={opciones}
											isMulti={true}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						{investigacionOriginal.documento && (
							<div className="text-center documento-actual">
								<h4>Documento actual</h4>
								<i className={documentoFileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + investigacionOriginal.documento.url}>{documentoFileData.nombre}</a>
								<hr className="mb-5" />
							</div>
						)}
						<h3>Documento</h3>
						<FileUpload
							title="Cambiar documento"
							accept=".pdf, .doc, .docx"
							buttonText="Elegir"
							buttonTextSingular="documento"
							updateFiles={(files) => { handleSeleccionDocumento(files, 'documento') }}
						/>
						<div className="py-4 text-center">
							<div style={{ width: '80%', marginLeft: '10%', borderBottomWidth: 1, borderBottomStyle: 'dotted', height: 1 }}></div>
						</div>
					</Col>
				</Row>)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarInvestigacion